module.exports = __webpack_public_path__ + "static/media/9.4b166915.jpg";